<div class="main-error-page">
  <div class="main-error-page__icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="144" height="144">
      <path
        style="stroke-width: 4"
        id="path2"
        d="m 69.2,81.8 h 6.2 V 32.6 h -6.2 z m 2.8,25.8 q 2,0 3.1,-1.1 1.1,-1.1 1.1,-3.1 0,-2 -1.1,-3.1 -1.1,-1.1 -3.1,-1.1 -2,0 -3.1,1.1 -1.1,1.1 -1.1,3.1 0,2 1.1,3.1 1.1,1.1 3.1,1.1 z M 72,144 Q 56.8,144 43.7,138.4 30.6,132.8 20.9,123.1 11.2,113.4 5.6,100.3 0,87.2 0,72 0,56.8 5.6,43.7 11.2,30.6 20.9,20.9 30.6,11.2 43.7,5.6 56.8,0 72,0 q 15.2,0 28.3,5.6 13.1,5.6 22.8,15.3 9.7,9.7 15.3,22.8 5.6,13.1 5.6,28.3 0,15.2 -5.6,28.3 -5.6,13.1 -15.3,22.8 -9.7,9.7 -22.8,15.3 Q 87.2,144 72,144 Z m 0,-72 q 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 z m 0,65.8 q 27.2,0 46.5,-19.3 Q 137.8,99.2 137.8,72 137.8,44.8 118.5,25.5 99.2,6.2 72,6.2 44.8,6.2 25.5,25.5 6.2,44.8 6.2,72 q 0,27.2 19.3,46.5 19.3,19.3 46.5,19.3 z" />
    </svg>
  </div>

  <h1 class="error-title">
    Whoops!
    <br />
    Da ist ein Fehler passiert :(
  </h1>
  <h2 class="error-subtitle">
    {{ message }}
  </h2>
</div>
